import qrcode from 'qrcode-generator';

/** Παράγει το QR ως inline SVG string (καθαρό JS, λειτουργεί σε web + native). */
export function qrSvg(text: string, cellSize = 4): string {
  const qr = qrcode(0, 'M'); // auto type, error correction level M
  qr.addData(text);
  qr.make();
  return qr.createSvgTag({ cellSize, margin: 1 });
}
